import styled from 'styled-components';

export const AppBody = styled.div`
	position: relative;
	margin: 0 auto;
	overflow: hidden !important;
	padding-top: 120px;
	height: 100%;
	width: 100%;
	min-width: 300px;
`;

export const AutoContainer = styled.div`
	position: static;
	max-width: 1200px;
	padding: 0px 15px;
	margin: 0px auto;
`;
